// 检测请求是否支持webp格式的中间件，
// 在nuxt里做是因为nuxt的中间件可以忽略对于静态资源的请求
import { isUndefined } from 'lodash';
import isNode from '../utils/isNode';
import parseCookie from '../utils/parseCookie';

const COOKIE_KEY = 'webp_enabled';
const cookieOptions = {
    maxAge: 30 * 24 * 3600 * 1000,
    domain: 'tuchong.com',
    httpOnly: false,
    signed: false,
};

export default function (context) {
    // 如果在浏览器 直接判断Cookie获取webp状态
    if (!isNode) {
        const cookie = parseCookie(document.cookie);
        context.commonData.webpEnabled = cookie[COOKIE_KEY] && cookie[COOKIE_KEY] === '1';
        return;
    }

    // 如果在服务端 先判断cookie中webp的状态 没有的话进行下一步判断
    if (isUndefined(context.req.eggContext.cookies.get(COOKIE_KEY))) {
        // 判断请求头里有没有image/webp
        if (context.req.eggContext.request.headers.accept && context.req.eggContext.request.headers.accept.includes('image/webp')) {
            context.req.eggContext.cookies.set(COOKIE_KEY, '1', cookieOptions);
            context.commonData.webpEnabled = true;
        } else if (context.req.eggContext.request.headers.accept && !context.req.eggContext.request.headers.accept.includes('image/webp')) {
            context.req.eggContext.cookies.set(COOKIE_KEY, '0', cookieOptions);
            context.commonData.webpEnabled = false;
        }
    }
}
